<template>
  <iframe ref="frame" :src="url" title="Form builder" class="gm-mailbaser-canvas" :style="{ height: height + 'px' }" sandbox="allow-scripts allow-same-origin" />
</template>
<script>
import assets from '../builders/assets.json';
export default {
  props: { document: { type: Object, required: true }, name: { type: String, default: '' }, archived: { type: Boolean, default: false } },
  data() { return { height: 740, channel: Array.from(crypto.getRandomValues(new Uint32Array(4))).join('-') }; },
  computed: { url() { return (process.env.BASE_URL || '/') + assets.entry + '?mode=form-design&channel=' + this.channel; } },
  mounted() { window.addEventListener('message', this.receive); },
  beforeDestroy() { window.removeEventListener('message', this.receive); },
  watch: { name() { this.initialize(); }, archived() { this.initialize(); } },
  methods: {
    initialize() { this.$refs.frame.contentWindow.postMessage({ type: 'groove:form-init', channel: this.channel, draft: { name: this.name, archived: this.archived, document: JSON.parse(JSON.stringify(this.document)) } }, location.origin); },
    receive(event) {
      if (event.origin !== location.origin || event.source !== this.$refs.frame.contentWindow || event.data?.channel !== this.channel) return;
      const message = event.data;
      if (message.type === 'groove:form-ready') this.initialize();
      if (message.type === 'groove:form-height' && Number.isFinite(message.height)) this.height = Math.min(30000, Math.max(420, Math.ceil(message.height) + 8));
      if (message.type === 'groove:form-change' && !this.archived && Array.isArray(message.document?.fields) && message.document.fields.length <= 50 && message.document.design && message.document.behavior) this.$emit('change', message.document);
    }
  }
};
</script>
<style scoped>
.gm-mailbaser-canvas { width: 100%; min-width: 0; display: block; border: 0; background: white; }
</style>
